<template>
  <div class="mb-8">
    <form :action="onboardPath" method="post" @submit="submitOnboard" data-remote="true" class="mt-6 flex">
      <input type="hidden" name="authenticity_token" :value="csrf" />
      <input type="hidden" name="add_favourites" :value="favouriteIds" />
      <input
        class="md:border md:border-black flex-grow md:py-2 px-4"
        name="email"
        placeholder="Enter your email here"
        type="email"
        ref="email"
        @focus="emailFocused"
        @blur="emailBlurred"
      />
      <input class="_btn _btn--black-white" name="button" type="submit" value="Confirm" />
    </form>
    <p class="mt-6 text-center">
      Already have an account?
      <a href="/login" class="text-primary"> Sign In </a>.
    </p>
  </div>
</template>

<script>
import { mapGetters } from "vuex"

export default {
  name: "Nav.Guest.OnboardingForm",
  props: ["onboardPath"],
  data() {
    return {
      csrf: document.querySelector('meta[name="csrf-token"]').content,
    }
  },
  methods: {
    submitOnboard(event) {
      if (this.$refs.email.value == "") {
        event.preventDefault()
        event.stopPropagation()
      } else {
        $("#bouncing-loader").removeClass("hidden")
        this.$emit("onboardSubmitted")
      }
    },
    emailFocused() {
      this.$emit("emailFocused")
    },
    emailBlurred() {
      this.$emit("emailBlurred")
    },
  },
  computed: {
    ...mapGetters("guest", ["favouriteIds"]),
  },
}
</script>
